import Model from "./Model";

export default class extends Model {
    async loadTable(
      page,
      limit,
      search = '',
      brand_id = null,
      client_id = null,
      device_type_id = null,
      device_software_id = null,
      version_id = null,
      date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                search,
                brand_id,
                client_id,
                device_type_id,
                device_software_id,
                version_id,
                date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: response.pages,
        };

        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(install_log => {
                let telem = {
                    tbody: {}
                };
                telem.id = install_log.id;
                telem.tbody.install_date_time = install_log.install_date_time;
                telem.tbody.error_log_path = install_log.error_log_path;
                telem.tbody.version_number = install_log.version_number;
                telem.tbody.status_description = install_log.status_description;
                telem.tbody.status_color = install_log.status_color;
                telem.tbody.location_number = install_log.location_number;
                telem.tbody.brand = install_log.brand;
                telem.tbody.client = install_log.client;
                telem.tbody.device_type = install_log.device_type;
                telem.tbody.software = install_log.software;
                telem.tbody.device_ip = install_log.device_ip;
                telem.tbody.location_number = install_log.location_number;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
